import React from 'react'
import { Manager, Reference, Popper } from 'react-popper'

import { zIndexes } from '../../variables.style'

import { useStyles } from './text-input.style'

export const TextInput = function ({ size, label, enableFocusAnimation = true, _ref, className = '', message, ...props }) {
  const classes = useStyles()
  return (
    <label>
      {label && <div className={(size === 'medium') ? 'form-element-label-medium' : 'form-element-label'}>{label}</div>}
      <div className="form-element-wrapper">
        <Manager>
          <Reference>
            {({ ref }) => (
              <div ref={ref}>
                <input data-qa={`text-input-${label}`} type="text" className={`form-element ${(size === 'medium') ? classes.inputMedium : classes.input} ${className}`} ref={_ref} {...props} />
                {enableFocusAnimation && <div className="form-element-border"></div>}
              </div>
            )}
          </Reference>
          {message &&
            <Popper placement="top-start" positionFixed={true}>
              {({ ref, style, placement, arrowProps }) => (
                <div ref={ref} style={{ ...style, zIndex: zIndexes.inputMessageTooltip }} data-placement={placement} className={`tooltip-content ${message.type}-message`}>
                  <div>{message.message}</div>
                  <div ref={arrowProps.ref} className="tooltip-tip" />
                </div>
              )}
            </Popper>
          }
        </Manager>
      </div>
    </label>
  )
}
